module.exports = __webpack_public_path__ + "static/media/client-loyola.1ab31d1b.png";